import React from "react";
import format from "date-fns/format";
import Calendar from "../calendar/Calendar";
import { ReactComponent as ChevronRight } from "../../assets/icons/chevron_right.svg";
import { ReactComponent as ChevronLeft } from "../../assets/icons/chevron_left.svg";
import { styled } from "styled-components";

const MonthNavButton = styled.button`
    display: flex;
    align-items: center;
    background-color: transparent !important;
    background-image: none;
    cursor: pointer;
    font-family: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    font-size: 100%;
    font-weight: inherit;
    line-height: 0 !important;
    color: inherit;
    margin: 0;
    padding: 0 !important;
    border: none !important;
    box-sizing: border-box;
    &:disabled {
        color: #adadbf;
        background-color: transparent !important;
    }
`;

function FilterCalendar({ onSelect, selectedValue, minBookingDate }) {
    const dateClickGandler = (date) => {
        const selectedDateFormatted = format(date, "yyyy-MM-dd");
        onSelect(selectedDateFormatted);
    };

    const dayClassName = (date) => {
        return "!se-w-[28px] !se-h-[28px] lg:!se-w-[36px] lg:!se-h-[36px] se-text-[15px]";
    };

    const weekDayClassName = (date) => {
        return "!se-w-[28px] !se-h-[28px] lg:!se-w-[36px] lg:!se-h-[36px]";
    };

    const customHeader = (monthDate, date, changeYear, changeMonth, customHeaderCount, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled) => {
        return (
            <div className="se-flex se-flex-col se-items-center se-gap-[14px]">
                <div className="se-flex se-justify-center se-items-center">
                    <MonthNavButton
                        type="button"
                        className="month-nav-button"
                        onClick={decreaseMonth}
                        disabled={prevMonthButtonDisabled}>
                        <ChevronLeft fill={prevMonthButtonDisabled ? "#adadbf" : "#ffffff"} />
                    </MonthNavButton>
                    <div className="se-text-[20px] se-font-bold se-uppercase se-mx-3 se-text-sneutral-450 se-font-[sans-serif] se-leading-[21.17px] se-antialiased">
                        {monthDate.toLocaleString("en-US", {
                            month: "long",
                            year: "numeric",
                        })}
                    </div>
                    <MonthNavButton
                        type="button"
                        className="month-nav-button"
                        onClick={increaseMonth}
                        disabled={nextMonthButtonDisabled}>
                        <ChevronRight fill={nextMonthButtonDisabled ? "#adadbf" : "#ffffff"} />
                    </MonthNavButton>
                </div>
            </div>
        );
    };

    return (
        <>
            <Calendar
                onChange={dateClickGandler}
                monthToShown={1}
                containerClassName="se-flex se-gap-[30px] !se-bg-transparent"
                customHeader={customHeader}
                dayClassName={dayClassName}
                weekDayClassName={weekDayClassName}
                defaultDate={selectedValue}
                minBookingDate={minBookingDate}
            />
        </>
    );
}

export default FilterCalendar;
